import { useDraggable, useDroppable } from '@dnd-kit/core';
import { shouldCancelDrag } from '../constants/constants';

export const useDragDrop = ({
  uniqueFindingId,
  lesionAllInfo,
  matched,
  isClustered,
  isMatchedMainRow,
  isPossibleMatch,
  draggedId,
  module_type,
  isPreviousFinding,
}) => {
  // Draggable configuration
  const isDraggableDisabled = matched || isClustered || isMatchedMainRow || isPreviousFinding;

  const {
    attributes: dragAttributes,
    listeners: dragListeners,
    setNodeRef: setDragNodeRef,
    transform: dragTransform,
    transition: dragTransition,
    isDragging,
  } = useDraggable({
    id: uniqueFindingId,
    disabled: isDraggableDisabled,
    data: { lesionAllInfo, type: 'opacity-row' },
  });

  // Droppable configuration - always call the hook
  const { setNodeRef: setDropNodeRef, isOver: dropIsOver } = useDroppable({
    id: `${uniqueFindingId}`,
    data: { lesionAllInfo, type: 'opacity-drop-zone' },
    disabled: !isPossibleMatch, // Disable the droppable if not a possible match
  });

  // Only use the drop state if it's a possible match
  const isOver = isPossibleMatch ? dropIsOver : false;
  const isThisItemDragging = isDragging && draggedId === uniqueFindingId;

  // Custom drag listeners that wrap the original ones
  const customDragListeners = dragListeners
    ? {
        ...dragListeners,
        onPointerDown: (event) => {
          // Prevent drag for microcalc
          if (module_type === 'microcalc') {
            event.stopPropagation();
            return;
          }

          if (shouldCancelDrag(event.target)) {
            event.stopPropagation();
            return;
          }

          // Only proceed if not disabled and original handler exists
          if (!isDraggableDisabled && dragListeners?.onPointerDown) {
            dragListeners.onPointerDown(event);
          }
        },
      }
    : {};

  // Combined node ref
  const setNodeRef = (node) => {
    setDragNodeRef(node);
    setDropNodeRef(node);
  };

  return {
    // Drag props
    dragAttributes,
    dragListeners: customDragListeners,
    isDragging: isThisItemDragging,
    draggedId,
    dragTransform,
    dragTransition,

    // Combined ref
    setNodeRef,

    // Drop state
    isOver,

    // Disable drag
    isDraggableDisabled,
  };
};
